import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { User } from './../models/user';
import { UserService } from './user.service';
import { HttpClient } from '@angular/common/http';

const CURRENT_USER_KEY = 'currentUser';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  private currentUser = new BehaviorSubject<User | null>(this.readStoredUser());
  currentUser$ = this.currentUser.asObservable();
  loggedIn$: Observable<any> = this.currentUser$.pipe(map(user => !!user));

  public host = environment.host;

  constructor(private httpClient: HttpClient, private userService: UserService) { }

  private readStoredUser(): User | null {
    if (typeof localStorage === 'undefined') {
      return null;
    }
    const raw = localStorage.getItem(CURRENT_USER_KEY);
    return raw ? JSON.parse(raw) : null;
  }

  public get currentUserValue(): User | null {
    return this.currentUser.value;
  }

  persistSession(user: User): void {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(CURRENT_USER_KEY, JSON.stringify(user));
    }
    this.currentUser.next(user);
  }

  login(username: string, password: string): Observable<User> {
    return this.userService.login(username, password).pipe(
      map(user => {
        if (user && user.access_token) {
          this.persistSession(user);
        }
        return user;
      })
    );
  }

  createNewUser(dataForm: any) {
    return new Promise<void>((resolve, reject) => {
      this.httpClient
        .post(this.host + '/createNewUser', dataForm)
        .toPromise()
        .then(
          () => {
            resolve();
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  logout(): void {
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem(CURRENT_USER_KEY);
    }
    this.currentUser.next(null);
  }
}
